import { API_BASE_URL } from 'sharedKernel/constants'

export const publicMeetingRoomApiUrl = (path: string): string => {
  const segment = path.replace(/^\//, '')
  const base = (API_BASE_URL ?? '').replace(/\/$/, '')
  return `${base}/${segment}`
}

export const PUBLIC_MEETING_ROOM_API = {
  LIST_ALL: 'v1/hotsite/meeting-room/all',
  // PLA-3423: criação, pré-checagem e by-status em v2 → new-zing-backend (bloqueio por reserva
  // aprovada + 409). Com a flag HOTSITE_MEETING_ROOM desligada o gateway reescreve pra v1 (legado).
  SAVE_RESERVATION: 'v2/hotsite/meeting-room/reservation',
  CHECK_AVAILABILITY: 'v2/hotsite/meeting-room/reservation/availability',
  CANCEL_RESERVATION: 'v1/hotsite/meeting-room/reservation/cancel',
  LIST_BY_STATUS: 'v2/hotsite/reservation-meeting-room/by-status',
  SETTINGS: 'v1/hotsite/meeting-room-settings',
} as const

export const PUBLIC_MEETING_ROOM_LIST_MAX_LIMIT = 2147483647

export const MEETING_ROOM_COVER_FILE_TYPE = 'coverImage'
export const MEETING_ROOM_SLIDER_FILE_TYPE = 'homePageSlider'
